import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const generateExcel = async (data, nameFile = 'export-data') => {
	// Create new workbook
	const workbook = new ExcelJS.Workbook();

	// Create sheet residue
	const sheet = workbook.addWorksheet('DATA');

	// Define columns
	sheet.addRow(Object.keys(data[0]));

	// Add new rows by data residues
	data.map(row => {
		sheet.addRow(Object.values(row));
	});

	// Generate buffer excel woorkbook
	const buffer = await workbook.xlsx.writeBuffer();

	// Create blob content excel
	const blob = new Blob([buffer], {
		type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	});

	// Save blob file
	saveAs(blob, `${nameFile}.xlsx`);
};
